import React, { useState } from "react"
import "./blog.css"

const BlogPostDetail = ({ post, onClose }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null)

  if (!post) return null

  const openPhotoModal = (photo) => {
    setSelectedPhoto(photo)
  }

  const closePhotoModal = () => {
    setSelectedPhoto(null)
  }

  return (
    <>
      <div className="blog-post-overlay" onClick={onClose}>
        <div className="blog-post-modal" onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={onClose}>
            <i className="fa fa-times"></i>
          </button>
          
          <div className="blog-post-header">
            <img src={post.cover} alt={post.title} className="blog-post-image" />
            <div className="blog-post-overlay-content">
              <div className="blog-post-category">{post.category}</div>
              <h1 className="blog-post-title">{post.title}</h1>
            </div>
          </div>
          
          <div className="blog-post-body">
            <div className="blog-post-meta">
              <div className="meta-item">
                <i className="fa fa-user"></i>
                <span>{post.type}</span>
              </div>
              <div className="meta-item">
                <i className="fa fa-calendar-alt"></i>
                <span>{post.date}</span>
              </div>
              <div className="meta-item">
                <i className="fa fa-clock"></i>
                <span>{post.readTime}</span>
              </div>
              <div className="meta-item">
                <i className="fa fa-comments"></i>
                <span>{post.com}</span>
              </div>
            </div>
            
            <div className="blog-post-content">
              <p>{post.desc}</p>
              
              {/* Extended content - you can add more paragraphs here */}
              {post.extendedContent && post.extendedContent.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* Photo Gallery Section */}
            {post.additionalPhotos && post.additionalPhotos.length > 0 && (
              <div className="photo-gallery-section">
                <h3>Photo Gallery</h3>
                <p>Explore more photos from this program and event</p>
                
                <div className="photo-gallery">
                  {post.additionalPhotos.map((photo, index) => (
                    <div key={index} className="gallery-item" onClick={() => openPhotoModal(photo)}>
                      <img src={photo} alt={`Gallery image ${index + 1}`} />
                      <div className="gallery-overlay">
                        <i className="fa fa-expand"></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            <div className="blog-post-footer">
              <div className="social-share">
                <span>Share this post:</span>
                <div className="share-buttons">
                  <button className="share-btn facebook">
                    <i className="fa fa-facebook"></i>
                  </button>
                  <button className="share-btn twitter">
                    <i className="fa fa-twitter"></i>
                  </button>
                  <button className="share-btn linkedin">
                    <i className="fa fa-linkedin"></i>
                  </button>
                  <button className="share-btn whatsapp">
                    <i className="fa fa-whatsapp"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Photo Modal */}
      {selectedPhoto && (
        <div className="photo-modal-overlay" onClick={closePhotoModal}>
          <div className="photo-modal" onClick={(e) => e.stopPropagation()}>
            <button className="photo-close-btn" onClick={closePhotoModal}>
              <i className="fa fa-times"></i>
            </button>
            <img src={selectedPhoto} alt="Full size photo" className="photo-modal-image" />
            <div className="photo-modal-info">
              <p>Click outside to close</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default BlogPostDetail
